import React from "react"
import { BsArrowUpRight } from "react-icons/bs"

function Project(props) {
    const openLink = () => props.link? window.open(props.link, '_blank', 'noopener,noreferrer') : null

    return (
        <div className="project">
            <h3 className="item_name" onClick={openLink} style={props.link? {cursor: "pointer"}: null}>
                {props.item_name}
                {props.link && <BsArrowUpRight className="external_icon"/>}
            </h3>
            <p className="item_description">{props.description}</p>
        </div>
    )
}

export default Project